export const Title = ({ obj, children }) => (
  <h1
    style={{ textAlign: 'center' }}
    id={obj.data.get('id') ? `paragraph-${obj.data.get('id')}` : undefined}
  >
    {children}
  </h1>
);
